// extracted by mini-css-extract-plugin
export default {"post":"Post_post__8VATO","capa":"Post_capa__dTzKE","titulo":"Post_titulo__8sABR","botaoLer":"Post_botaoLer__TzDW8"};